import type { AxiosInstance } from 'axios';

export default (http: AxiosInstance) => ({
    async healthCheck() {
        const res = await http.get<AppResponseEmpty>('/health-check');
        return res.data;
    }
} as const);
